import styled, { keyframes } from 'styled-components';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 4rem;

  position: sticky;
  top: 0;

  @media (max-width: 768px) {
    padding: 0 2rem;
  }

  button {
    width: fit-content;

    height: 5rem;

    @media (max-width: 1024px) {
      width: fit-content;
    }
  }
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Sidebar = styled.div`
  width: 10rem;
  height: 100%;

  border-right: 1px solid #cfcfcf;

  > ul {
    > li {
      display: flex;
      align-items: center;

      height: 5.2rem;
      padding-left: 1rem;

      cursor: pointer;
      transition: ${({ theme }) => theme.transition.default};

      > p {
        font-size: 1.6rem;
        line-height: 3.5rem;
        color: #ffffff;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      :hover {
        background: #242424;
      }

      &.active {
        background: #242424;
        border-right: 4px solid #ffd503;

        > p {
          font-weight: bold;
          color: #ffdf22;
        }
      }

      @media (min-width: 768px) {
        padding-left: 3.2rem;

        > p {
          font-size: 1.9rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    width: 27rem;
  }
`;

export const Container = styled.div`
  background: #0f0f0f;

  display: flex;
  overflow: hidden;

  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const CreateContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding: 5rem 3rem;

  form {
    width: 80%;
  }

  h1 {
    padding-bottom: 2rem;
  }

  fieldset {
    border: none;
    width: 100%;

    padding-bottom: 2.8rem;

    p {
      padding-bottom: 0.5rem;
      font-weight: bold;
      padding-left: 1.5rem;
    }
    div {
      border-radius: 2rem;
    }
  }

  button {
    width: 60%;
    height: 5rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 80%;
  flex: 1;
  overflow: auto;

  animation: ${appearOpacity} 0.5s ease-in;
`;
